import { ISearchParams } from './interface';

export const getTotalGuestsFromSearch = (searchParams: ISearchParams) => {
  const { adults, children } = searchParams;
  const adultsValue = adults > 0 ? adults : 1;
  const childrenValue = children > 0 ? children : 0;

  return adultsValue + childrenValue;
};
